import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { FileDigitale } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { FormikSelectVocabolario } from "./formsHelpers"

export default function FileDigitaleFileForm({ item, save, ref }: FormInDialogProps<FileDigitale>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return item ?? {}
  }, [item])

  const schema = useMemo(() => yup.object().shape({}), [t])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as FileDigitale).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={6}>
                <Field
                  name="formato_file"
                  label={t("fileDigitale.formato_file")}
                  component={FormikSelectVocabolario}
                  vocabolario="formato_file"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={6}>
                <Field
                  name="dimensione_file"
                  label={t("fileDigitale.dimensione_file")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid size={6}>
                <Field
                  name="framerate"
                  label={t("fileDigitale.framerate")}
                  component={FormikSelectVocabolario}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  vocabolario="framerate"
                />
              </Grid>
              <Grid size={6}>
                <Field
                  name="codec"
                  label={t("fileDigitale.codec")}
                  component={FormikSelectVocabolario}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  vocabolario="codec"
                />
              </Grid>

              <Grid size={6}>
                <Field
                  name="risoluzione"
                  label={t("fileDigitale.risoluzione")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>

              <Grid size={6}>
                <Field
                  name="durata"
                  label={t("fileDigitale.durata")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid size={6}>
                <Field
                  name="bit_depth"
                  label={t("fileDigitale.bit_depth")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>

              <Grid size={6}>
                <Field
                  name="aspect_ratio"
                  label={t("fileDigitale.aspect_ratio")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>

              

              <Grid size={6}>
                <Field
                  name="sistema_colore"
                  label={t("fileDigitale.sistema_colore")}
                  component={FormikSelectVocabolario}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  vocabolario="sistema_colore"
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
